<ion-header no-shadow no-border>
  <ion-toolbar>
    <ion-title>Pago</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/transportec/search" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" *ngIf="ticket">
  <ion-card color="light">
    <ion-card-header>
      <ion-item lines="full">
        <ion-icon slot="start" src="/assets/icon/tickets.svg" color="primary"></ion-icon>
        <ion-label color="primary">Resumen</ion-label>
      </ion-item>
    </ion-card-header>

    <ion-card-content>
      <p>1 X Boleto Transporte</p>
      <p *ngIf="ticket.search.type==='go'">Desde: {{ticket.search.stop.name}}</p>
      <p *ngIf="ticket.search.type==='return'">Hacia: {{ticket.search.stop.name}}</p>
      <p>Fecha: {{ticket.search.date | toDatestring:'date'}}</p>
      <p>Hora: {{ticket.trip.starts_at | slice:0:5}}</p>
      <p *ngIf="!ticket.trip.discount">Precio: ${{ticket.trip.amount | number}}</p>
      <div *ngIf="ticket.trip.discount">
        <p>Precio: ${{ticket.trip.amount+ticket.trip.discount | number}}</p>
        <p>Descuento: ${{ticket.trip.discount | number}}</p>
        <p>A pagar: ${{ticket.trip.amount | number}}</p>
      </div>
    </ion-card-content>
  </ion-card>
  <div class="ion-padding pay-with">
    <p>Pagar con:</p>
    <ion-item
      color="primary"
      *ngIf="(balance | typeof) === 'number'"
      (click)="balance >= ticket.trip.amount && goWallet()"
      [class.noFunds]="balance < ticket.trip.amount"
    >
      <ion-icon slot="start" src="/assets/icon/wallet.svg"></ion-icon>
      <ion-label>
        Wallet
        <br />
        Balance
        <span class="price">${{balance | number}}</span>
      </ion-label>
      <ion-icon name="ios-arrow-forward" slot="end"></ion-icon>
    </ion-item>
    <ion-card (click)="goPay('credit_card_paycode')" *ngIf="vendorsStore.isPayCodeActive()">
      <img src="assets/imgs/creditcard.jpg" />
      <p>PayCode</p>
    </ion-card>
    <ion-card (click)="goPay('credit_card')" *ngIf="vendorsStore.isConektaActive()">
      <img src="assets/imgs/creditcard.jpg" />
      <p>Conekta</p>
    </ion-card>
    <ion-card (click)="goPay('credit_card_openpay')" *ngIf="vendorsStore.isOpenPayActive()">
      <img src="assets/imgs/creditcard.jpg" />
      <p>OpenPay</p>
    </ion-card>
    <ion-card *ngIf="vendorsStore.paypalKey() && amount" class="ion-padding">
      <app-payment-paypal
        [clientId]="vendorsStore.paypalKey()!"
        [amount]="amount"
        (paymentSuccess)="onPayPalSuccess($event)"
        (error)="onPayPalError($event)"
      ></app-payment-paypal>
      <p>PayPal</p>
    </ion-card>
    <ion-item
      color="primary"
      (click)="subscription && goSwap()"
      *ngIf="subscription && subscription.name !=='PV' && subscription.swap"
    >
      <ion-icon slot="start" src="/assets/icon/roundtrip-icon.svg"></ion-icon>
      <ion-label>
        Suscripción
        <br />
        Canje de boleto
      </ion-label>
      <ion-icon name="ios-arrow-forward" slot="end"></ion-icon>
    </ion-item>
  </div>
</ion-content>
